// extracted by mini-css-extract-plugin
export const content = "layout-module--content--3GWBe";
export const footer = "layout-module--footer--3iD_9";
export const footerWrapper = "layout-module--footerWrapper--18z66";
export const companyAddress = "layout-module--companyAddress--3Nz5d";
export const siteInfo = "layout-module--siteInfo--19z4I";